import * as React from 'react';
import './NavBar.css';

const NavBar = () => {
    return (
        <header>
            <nav>
                <h3>My City</h3>
            </nav>
        </header>
    );
}

export default NavBar;